import * as React from "react"
import { Link } from "gatsby"
import { Stack, Typography } from "@mui/material"

import SEO from "../components/seo"

const NotFoundPage = () => {
    return (<>
        <Stack style={{ height: "60vh" }} justifyContent="center" alignItems={"center"}><Typography color="white" variant="h4">This page doesn't exist. :(</Typography></Stack>
    </>
    )
}

export default NotFoundPage

export const Head = () => {
    return <SEO title="404" description="This page doesnt exist" pathname="/404"></SEO>
}
